/*
 * @,@Author: ,: chenxupeng.cxp@bytedance.com
 * @,@LastEditors: ,: chenxupeng.cxp@bytedance.com
 */
import Vue from 'vue';
import Vuei18n from 'vue-i18n';
Vue.use(Vuei18n);
import ja from './ja.js';

const i18n = new Vuei18n({
    locale: 'ja', // 语言
    // locale: navigator.language || 'ja', // 语言
    silentTranslationWarn: true,
    // locale: 'ja', // 语言
    messages: {
        ja, // 日语
    },
});
export default i18n;
